'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = doSeries;

var _eachOfSeries = require('../eachOfSeries');

var _eachOfSeries2 = _interopRequireDefault(_eachOfSeries);

var _wrapAsync = require('./wrapAsync');

var _wrapAsync2 = _interopRequireDefault(_wrapAsync);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function doSeries(fn) {
    return function (obj, iteratee, callback) {
        return fn(_eachOfSeries2.default, obj, (0, _wrapAsync2.default)(iteratee), callback);
    };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-recaptcha/.yarn-cache/v1/npm-async-2.4.1-62a56b279c98a11d0987096a01cc3eeb8eb7bbd7/internal/doSeries.js
// module id = 1072
// module chunks = 0